import { create } from 'zustand';

export type AcquiringStore = {
    isAcquiring: boolean;
    setIsAcquiring: (value: boolean) => void;
    cleanUpAcquiringStore: () => void;
};

export const useAcquiringStore = create<AcquiringStore>((set) => ({
    isAcquiring: false,
    setIsAcquiring: (isAcquiring) => {
        set(() => ({
            isAcquiring,
        }));
    },
    cleanUpAcquiringStore: () => {
        set(() => ({
            isAcquiring: false,
        }));
    },
}));
